<template>
    <VirtualsResults :gameName="'ballsix'"></VirtualsResults>
</template>

<script>
import VirtualsResults from './Components/VirtualsResults';
export default {
    name: 'ballsix',
    components: {
        VirtualsResults,
    },
};
</script>
